// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GarhwaliCategories_container__weoqi {
    width: 100%;
    box-sizing: border-box;
    max-width: 95%;
    margin: 0 auto;
    padding-top: 10px;
  }
  
  .GarhwaliCategories_book_grid_container__Np\\+gT {
    margin-bottom: 30px;
  }
  
  .GarhwaliCategories_author_header__Jf-SN {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .GarhwaliCategories_heading__QL3og {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }
  
 
  
  .GarhwaliCategories_view_more__2-mrN:hover {
    text-decoration: underline;
  }
  
  .GarhwaliCategories_book_grid__-HQ0l {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
  }
  
  .GarhwaliCategories_grid_item__8ZFkw {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .GarhwaliCategories_book_image__5xgsj {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    cursor: pointer;
  }
  
  .GarhwaliCategories_book_image__5xgsj:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  /* Responsive Layout */
  @media (max-width: 1200px) {
    .GarhwaliCategories_book_grid__-HQ0l {
      grid-template-columns: repeat(6, 1fr);
    }
  }
  
  @media (max-width: 992px) {
    .GarhwaliCategories_book_grid__-HQ0l {
      grid-template-columns: repeat(5, 1fr);
      gap: 15px;
    }
  }
  
  @media (max-width: 768px) {
    .GarhwaliCategories_book_grid__-HQ0l {
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;
    }
    
    .GarhwaliCategories_container__weoqi {
      padding: 15px;
    }
  }
  
  @media (max-width: 576px) {
    .GarhwaliCategories_book_grid__-HQ0l {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
    }
    
    .GarhwaliCategories_container__weoqi {
      padding: 10px;
    }
    
    .GarhwaliCategories_heading__QL3og {
      font-size: 1.2rem;
    }
  }
  
  @media (max-width: 320px) {
    .GarhwaliCategories_book_grid__-HQ0l {
      grid-template-columns: repeat(2, 1fr);
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/GarhwaliCategories.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;EACX;;;;EAIA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA,sBAAsB;EACtB;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;EACF;;EAEA;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF","sourcesContent":[".container {\n    width: 100%;\n    box-sizing: border-box;\n    max-width: 95%;\n    margin: 0 auto;\n    padding-top: 10px;\n  }\n  \n  .book_grid_container {\n    margin-bottom: 30px;\n  }\n  \n  .author_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .heading {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0;\n  }\n  \n \n  \n  .view_more:hover {\n    text-decoration: underline;\n  }\n  \n  .book_grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 10px;\n  }\n  \n  .grid_item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .book_image {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .book_image:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* Responsive Layout */\n  @media (max-width: 1200px) {\n    .book_grid {\n      grid-template-columns: repeat(6, 1fr);\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .book_grid {\n      grid-template-columns: repeat(5, 1fr);\n      gap: 15px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .book_grid {\n      grid-template-columns: repeat(4, 1fr);\n      gap: 15px;\n    }\n    \n    .container {\n      padding: 15px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .book_grid {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 10px;\n    }\n    \n    .container {\n      padding: 10px;\n    }\n    \n    .heading {\n      font-size: 1.2rem;\n    }\n  }\n  \n  @media (max-width: 320px) {\n    .book_grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GarhwaliCategories_container__weoqi`,
	"book_grid_container": `GarhwaliCategories_book_grid_container__Np+gT`,
	"author_header": `GarhwaliCategories_author_header__Jf-SN`,
	"heading": `GarhwaliCategories_heading__QL3og`,
	"view_more": `GarhwaliCategories_view_more__2-mrN`,
	"book_grid": `GarhwaliCategories_book_grid__-HQ0l`,
	"grid_item": `GarhwaliCategories_grid_item__8ZFkw`,
	"book_image": `GarhwaliCategories_book_image__5xgsj`
};
export default ___CSS_LOADER_EXPORT___;
